import { effects } from 'redux-saga'

import { isEmpty } from 'internal-components/src/records/CreditCard'
import encryptValue from 'internal-components/src/util/eCrypt'

import callWithHmac from 'internal-components/src/redux/sagas/effects/callWithHmac'
import handleViolations from 'internal-components/src/redux/sagas/effects/handleViolations'
import { receiveSignup } from 'internal-components/src/redux/modules/signup/actions'
import {
  addErrors,
  beginWork,
  clearErrors,
  editSignup,
  endWork,
} from '../../modules/signupEdit/actions'

export default function* createToken(
  { invocation },
  signup,
  sourceId,
  contactDetails,
  allowSkip = false,
) {
  try {
    if (isEmpty(sourceId) && allowSkip) {
      return true
    }

    yield effects.put.resolve(beginWork())
    yield effects.put.resolve(clearErrors())

    const result = yield effects.call(
      callWithHmac,
      invocation.signupCreateToken,
      signup,
      sourceId,
      contactDetails,
    )

    yield effects.put.resolve(receiveSignup(result.signup))
    yield effects.put.resolve(editSignup(result.signup.id))

    return true
  } catch (e) {
    yield effects.call(handleViolations, e, addErrors)
  } finally {
    yield effects.put.resolve(endWork())
  }

  return false
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/createToken.js